import { Head, Link } from '@inertiajs/react'
import Form from './form'
import type { TaxCategoryType } from './types'

interface NewProps {
  tax_category: TaxCategoryType
}

export default function New({ tax_category }: NewProps) {
  return (
    <>
      <Head title="New tax category" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">New tax category</h1>

        <Form
          tax_category={tax_category}
          method="post"
          action="/tax_categories"
          submitText="Create Tax category"
        />

        <Link
          href="/tax_categories"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Back to tax categories
        </Link>
      </div>
    </>
  )
}
